module.exports = __webpack_public_path__ + "img/TRAVEL_AGENCY.9ab92eb2.png";